import { useCallback, useEffect, useRef, useState } from 'react';

export function useSaveState<T>(initialFilters: T, localStorageKey: string) {
  const readFromStorage = useCallback(() => {
    if (typeof window === 'undefined') return initialFilters; // SSR-safe
    const stored = localStorage.getItem(localStorageKey);
    return stored ? (JSON.parse(stored) as T) : initialFilters;
  }, [initialFilters, localStorageKey]);

  const skipSaveRef = useRef(false);
  const [filters, setFilters] = useState<T>(readFromStorage);

  useEffect(() => {
    skipSaveRef.current = true;
    setFilters(readFromStorage());
  }, [localStorageKey]);

  useEffect(() => {
    if (skipSaveRef.current) {
      skipSaveRef.current = false;
      return;
    }
    localStorage.setItem(localStorageKey, JSON.stringify(filters));
  }, [filters, localStorageKey]);

  return [filters, setFilters] as const;
}
